module.exports = __webpack_public_path__ + "img/anniversary_2023-title.8c512ef6.svg";